import React from 'react';
import LoadingSpinner from '../Layout/LoadingSpinner';
import styles from './AlertComponent.module.css';

interface LoaderProps {
  isLoading: boolean;
}

const Loader: React.FC<LoaderProps> = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.loaderWrapper}>
        <LoadingSpinner size="large" />
      </div>
    </div>
  );
};

export default Loader;
